import {
    CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK,
    CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK,
    CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK,
    DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK,
    DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK,
    DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK,
    FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST_DK,
    FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE_DK,
    UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK,
    UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK,
    RESET_PRINTING_DC_INWARD_DETAILS_INFO_DK,
    CREATE_PRINTING_DC_INWARD_DETAILS_FORM_DK,
    UPDATE_PRINTING_DC_INWARD_DETAILS_FORM_DK,
    FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS_DK,
    PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './printingDcInwardDetails.actionsType';

export const PRINTING_DC_INWARD_DETAILS_DK = 'printingDcInwardDetailsDK';

let initialState = {
    loading: false,
    printingDcInwardDetails: [],
    isDisabledDC: false,
    printingDcInwardDetailsWithoutId: [],
    previousGetList: [],
    printingDcInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let printingDcInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRINTING_DC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK:
        case DELETE_PRINTING_DC_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetails: updatePayload
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsWithoutId: updatePayload
            };
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.PRI
            };
        case CREATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case UPDATE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: updatePayload
            };
        case DELETE_PRINTING_DC_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case RESET_PRINTING_DC_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                printingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isDisabledDC: false
            };
        case CREATE_PRINTING_DC_INWARD_DETAILS_FORM_DK:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                printingDcInwardDetailsForm: {
                    ...state.printingDcInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case PRINTING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
            return {
                ...state,
                isDisabledDC: payload
            };
        case FETCH_PRINTING_DC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_PRINTING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK:
        case DELETE_PRINTING_DC_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
